(function () {
  let lastClosedAt = 0;
  const isTouchDevice = () => window.matchMedia('(pointer: coarse)').matches;

  function getActiveImg(modal) {
    const imgs = modal.querySelectorAll('img.global-media-settings');
    const content = modal.querySelector('.product-media-modal__content');
    if (!content) return imgs[0] || null;
    const containerRect = content.getBoundingClientRect();
    for (const img of imgs) {
      const r = img.getBoundingClientRect();
      if (r.top < containerRect.bottom && r.bottom > containerRect.top) return img;
    }
    return imgs[0] || null;
  }

  function enablePinchZoom(modal) {
    let scale = 1, startDist = 0, startScale = 1;
    let originX = 0, originY = 0;
    let isPinching = false;
    let hasMoved = false;
    let gestureActive = false;
    let touchStartX = 0, touchStartY = 0;
    let activeImg = null;
    const content = modal.querySelector('.product-media-modal__content');

    function dist(touches) {
      return Math.hypot(
        touches[0].clientX - touches[1].clientX,
        touches[0].clientY - touches[1].clientY
      );
    }

    function applyTransform() {
      if (!activeImg) return;
      activeImg.style.transform = `translate(${originX}px, ${originY}px) scale(${scale})`;
      activeImg.style.transformOrigin = 'center center';
    }

    function resetZoom() {
      if (activeImg) {
        activeImg.style.transform = '';
        activeImg.style.transformOrigin = '';
        activeImg.style.zIndex = '';
        activeImg.style.position = '';
      }
      if (content && isTouchDevice()) {
        content.style.overflow = '';
        content.style.touchAction = '';
      }
      scale = 1; originX = 0; originY = 0;
      activeImg = null;
    }

    function closeModal() {
      if (!modal.openedBy) {
        modal.openedBy = modal.querySelector('.product-media-modal__toggle') || document.body;
      }
      lastClosedAt = Date.now();
      modal.hide();
      modal.style.display = 'none';
      setTimeout(() => { modal.style.display = ''; }, 350);
      resetZoom();
      setTimeout(() => {
        const c = modal.querySelector('.product-media-modal__content');
        if (c) { c.style.overflow = ''; c.style.touchAction = ''; }
      }, 400);
    }

    modal.addEventListener('touchstart', (e) => {
      if (e.touches.length === 2) {
        if (!gestureActive) hasMoved = false;
        gestureActive = true;
        isPinching = true;
        activeImg = activeImg || getActiveImg(modal);
        if (!activeImg) return;
        startDist = dist(e.touches);
        startScale = scale;
        if (content && isTouchDevice()) {
          content.style.overflow = 'hidden';
          content.style.touchAction = 'none';
        }
        activeImg.style.zIndex = '10';
        activeImg.style.position = 'relative';
      } else if (e.touches.length === 1) {
        gestureActive = true;
        hasMoved = false;
        isPinching = false;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        activeImg = activeImg || getActiveImg(modal);
        if (content && isTouchDevice()) content.style.touchAction = 'none';
      }
    }, { passive: true });

    modal.addEventListener('touchmove', (e) => {
      if (e.touches.length === 2 && isPinching && activeImg) {
        e.preventDefault();
        hasMoved = true;
        scale = Math.min(Math.max(startScale * (dist(e.touches) / startDist), 1), 4);
        applyTransform();
      } else if (e.touches.length === 1 && activeImg && !isPinching) {
        const dx = e.touches[0].clientX - touchStartX;
        const dy = e.touches[0].clientY - touchStartY;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) {
          hasMoved = true;
          if (scale > 1) {
            e.preventDefault();
            originX += dx;
            originY += dy;
            applyTransform();
          }
        }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }
    }, { passive: false });

    modal.addEventListener('touchend', (e) => {
      if (e.touches.length >= 1) {
        if (e.touches.length === 1) {
          isPinching = false;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }
        return;
      }

      gestureActive = false;

      if (hasMoved) {
        hasMoved = false;
        isPinching = false;
        if (content && isTouchDevice()) content.style.touchAction = '';
        if (scale <= 1 && content && isTouchDevice()) content.style.overflow = '';
        return;
      }

      // Schone tap
      e.preventDefault();
      isPinching = false;
      hasMoved = false;
      closeModal();
    }, { passive: false });
  }

  function initZoomOnModal() {
    // Blokkeer modal-openers kort na sluiten via tap
    document.addEventListener('click', (e) => {
      if (Date.now() - lastClosedAt < 400) {
        const opener = e.target.closest('modal-opener, [data-modal]');
        if (opener) {
          e.stopPropagation();
          e.preventDefault();
        }
      }
    }, { capture: true });

    const observer = new MutationObserver(() => {
      document.querySelectorAll('product-modal').forEach((modal) => {
        if (!modal.dataset.zoomEnabled) {
          modal.dataset.zoomEnabled = 'true';
          enablePinchZoom(modal);

          // Reset content stijlen bij elke modal opening
          new MutationObserver(() => {
            if (modal.hasAttribute('open')) {
              const c = modal.querySelector('.product-media-modal__content');
              if (c) { c.style.overflow = ''; c.style.touchAction = ''; }
            }
          }).observe(modal, { attributes: true, attributeFilter: ['open'] });

          // Toon alleen actieve afbeelding in modal
          new MutationObserver(() => {
            if (modal.hasAttribute('open')) {
              const activeMediaId = modal.openedBy && modal.openedBy.getAttribute('data-media-id');
              modal.querySelectorAll('img.global-media-settings').forEach((img) => {
                if (activeMediaId && img.getAttribute('data-media-id') !== activeMediaId) {
                  img.style.display = 'none';
                } else {
                  img.style.display = '';
                }
              });
            } else {
              modal.querySelectorAll('img.global-media-settings').forEach((img) => {
                img.style.display = '';
              });
            }
          }).observe(modal, { attributes: true, attributeFilter: ['open'] });
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoomOnModal);
  } else {
    initZoomOnModal();
  }
})();
